import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth-service.service';
import { CurrentUserService } from '../current-user.service';
import { Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { NbSidebarService, NbToastrService } from '@nebular/theme';
import { alert } from 'devextreme/ui/dialog';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { _, TranslateService } from '@ngx-translate/core';
import { loadMessages, locale } from 'devextreme/localization';
import * as Sentry from "@sentry/angular";

import deMessages from "devextreme/localization/messages/de.json";
import nlMessages from "devextreme/localization/messages/nl.json";

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss']
})
export class UserHeaderComponent implements OnInit, OnDestroy {
  @Input() PresenterModusEnabled: boolean = false;
  @ViewChild(DxSelectBoxComponent) selectbox: DxSelectBoxComponent;
  @ViewChild('activeAfdelingSelectBox') afdelingSelectBox: DxSelectBoxComponent;
  activeCustomer: any = new Customer();
  activeAfdelingId: number;
  customers: any[] = [];
  popupVisible: boolean;
  customerLogoUrl: SafeUrl;
  showLogo: boolean = false;
  loadingVisible: boolean = false;
  showDepartmentBox: boolean = false;
  showLanguageWindow: boolean = false;

  private setCustomerSubscription: Subscription;

  constructor(private _service: CurrentUserService, private _authService: AuthService, private _jwtHelper: JwtHelperService, private router: Router, private toastrService: NbToastrService,
    private sidebarService: NbSidebarService, private _currentUserService: CurrentUserService, private _translateService: TranslateService) {
    this.customerLogoUrl = environment.API_URL + "klantlogo";

    loadMessages(deMessages);
    loadMessages(nlMessages);

    const pf = this._currentUserService.getUserPreferredLanguage();
    if (!!pf) {
      this._translateService.use(pf);
      locale(pf);
    } else {
      //todo: dit moet weer aan als we meerdere talen gaan ondersteunen: this.showLanguageWindow = true;      
      const pf = 'nl';
      this._translateService.use(pf);
      locale(pf);
    }

    Sentry.setUser({
      id: _authService.getUserId(),
      username: _authService.getUserName(),
      email: _authService.getEmail(),
      name: _authService.getName(),
    });

  }

  ngOnInit() {
    this.popupVisible = true;
    this._service.getAvailableCustomers().subscribe(data => {
      this.customers = data;
      this.loadActiveCustomer();
    });

    this.setCustomerSubscription = this._service.OnSetCurrentCustomer().subscribe((customer) => {
      this.setActiveKlant(customer);
    });

    if (this.showLanguageWindow) {
      this._currentUserService.showChooseLanguage();
    }
  }

  loadActiveCustomer() {
    this._service.getActiveCustomer().subscribe((data) => {
      this.activeCustomer = data;
      if (this.customers.length > 1 && !!this.selectbox) this.selectbox.instance.option('value', this.activeCustomer.KlantId);

      this.activeAfdelingId = parseInt(this._authService.getDecodedToken()['ActiveAfdelingId']);
      if (!!this.afdelingSelectBox) this.afdelingSelectBox.instance.option('value', this.activeAfdelingId);

      Sentry.setUser({
        id: this._authService.getUserId(),
        username: this._authService.getUserName(),
        email: this._authService.getEmail(),
        name: this._authService.getName(),
      });
      if (this.activeCustomer.Afdelingen.length > 1) {
        this.showDepartmentBox = true;
      } else {
        this.showDepartmentBox = false;
      }

      const subscriptionExpiresInDays = this._authService.getSubscriptionExpiresInDays();
      if (subscriptionExpiresInDays == 0) {
        alert(this._translateService.instant('LICENTIE.VERLOPEN.TEKST',
          {
            customerName: this.activeCustomer.Naam,
          }
        ),
          this._translateService.instant('LICENTIE.VERLOPEN.TITEL'));
        this.sidebarService.collapse('menu-sidebar');
        this.router.navigate(['pages', 'expired']);
      } else if (subscriptionExpiresInDays > 0 && subscriptionExpiresInDays <= 30) {
        alert(this._translateService.instant('LICENTIE.BIJNA_VERLOPEN.TEKST',
          {
            customerName: this.activeCustomer.Naam,
            numberOfDays: subscriptionExpiresInDays,
            dayLabel: subscriptionExpiresInDays == 1 ? this._translateService.instant('INFO.LICENTIE.DAG') : this._translateService.instant('INFO.LICENTIE.DAGEN')
          }
        ),
          this._translateService.instant('LICENTIE.BIJNA_VERLOPEN.TITEL'));
      }
    });
  }

  setActiveKlant(customer) {
    if (!this._jwtHelper.isTokenExpired()) {
      this.loadingVisible = true;
      this.activeCustomer = customer;
      this._authService.refreshTokens(customer.KlantId).subscribe({
        next: token => {
          localStorage.setItem(environment.DEFAULT_TOKEN_NAME, token.access_token);
          localStorage.setItem(environment.DEFAULT_REFRESH_TOKEN_NAME, token.refresh_token);
          this.loadActiveCustomer();
          this._authService.logLogon().subscribe();
          this._authService.startRefreshTokenTimer();
          this.loadingVisible = false;

          if (this.router.url != this._authService.getStartPageUrl()) {
            this.router.navigateByUrl(this._authService.getStartPageUrl())
              .then(() => {
                this._currentUserService.changeCurrentCustomer();
              })
              .catch(() => {
                this._currentUserService.changeCurrentCustomer(); // Ook bij navigatiefout
              });
          } else {
            this._currentUserService.changeCurrentCustomer();
          }
        }, error: error => {
          alert('De sessie is verlopen, log opnieuw in.', 'De sessie is verlopen').then(() => {
            this.router.navigate(['auth', 'login']);
          });
          this._authService.logFailedLogon();
        }
      });
    } else {
      alert('De sessie is verlopen, log opnieuw in.', 'De sessie is verlopen').then(() => {
        this.router.navigate(['auth', 'login']);
      });
    }
  }

  onSelectionChanged(event) {
    if (event.selectedItem.KlantId != this.activeCustomer.KlantId) {
      this.setActiveKlant(event.selectedItem);
    }
  }

  onAfdelingChanged(event) {
    if (event.selectedItem == null || event.selectedItem.AfdelingId == this.activeAfdelingId) {
      return;
    } else

      if (!this._jwtHelper.isTokenExpired()) {
        this.loadingVisible = true;
        this.activeAfdelingId = event.selectedItem.AfdelingId;
        this._authService.changeActiveDepartment(this.activeCustomer.KlantId, this.activeAfdelingId).subscribe({
          next: token => {
            localStorage.setItem(environment.DEFAULT_TOKEN_NAME, token.access_token);
            localStorage.setItem(environment.DEFAULT_REFRESH_TOKEN_NAME, token.refresh_token);
            this._currentUserService.changeCurrentAfdeling();
            this._authService.startRefreshTokenTimer();
            this.loadingVisible = false;

            //Sentry.setTag("activeAfdelingId", this.activeAfdelingId);
            Sentry.setUser({
              id: this._authService.getUserId(),
              username: this._authService.getUserName(),
              email: this._authService.getEmail(),
              name: this._authService.getName(),
            });

          }, error: error => {
            alert('De actieve afdeling kan niet worden gewijzigd, probeer het nogmaals of neem contact op met Kenbri..', 'Opgelet!').then(() => {
              this.router.navigate(['auth', 'login']);
            });
            this._authService.logFailedLogon();
          }
        });

      } else {
        alert('De sessie is verlopen, log opnieuw in.', 'De sessie is verlopen').then(() => {
          this.router.navigate(['auth', 'login']);
        });
      }
  }

  ngOnDestroy(): void {
    this.setCustomerSubscription.unsubscribe();
  }
}

export class Customer {
  Naam: string;
  KlantId: number;
  EindDatumTotalCare: Date;
  Afdelingen: any[];
}

